import { ArrowUpRight, MapPin, MessageCircle } from "lucide-react";
import SectionLabel from "./SectionLabel";
import { Reveal } from "./Reveal";

export default function Contact() {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="scroll-mt-20 bg-white px-6 py-28 text-[#161511] sm:py-36"
        >
            <div className="mx-auto max-w-4xl text-center">
                <SectionLabel id="contact" tone="light">
                    Contact
                </SectionLabel>
                <Reveal delay={0.1}>
                    <span
                        data-testid="contact-logo"
                        className="logo-feather-x mx-auto mt-10 block w-64 sm:w-80"
                    >
                        <img
                            src="/logo-light.png"
                            alt="Mountain View Pictures"
                            className="logo-feather-y w-full select-none"
                        />
                    </span>
                </Reveal>
                <Reveal delay={0.18}>
                    <a
                        href="mailto:admin@mountainviewpictures.com"
                        data-testid="contact-email-link"
                        className="link-sweep mt-10 inline-block break-words font-display text-[clamp(1.45rem,4.2vw,3.1rem)] font-light leading-tight text-[#161511] transition-colors duration-500 hover:text-[#8a6d28]"
                    >
                        admin@mountainviewpictures.com
                    </a>
                </Reveal>
                <Reveal
                    delay={0.26}
                    className="mt-12 flex flex-col items-center justify-center gap-6 text-sm tracking-wide text-[#161511]/80 sm:flex-row sm:gap-12"
                >
                    <a
                        href="https://wa.me/918122275811"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-whatsapp-link"
                        className="inline-flex items-center gap-2 transition-colors duration-300 hover:text-[#8a6d28]"
                    >
                        <MessageCircle
                            className="h-4 w-4 text-[#8a6d28]"
                            aria-hidden="true"
                        />
                        WhatsApp — +91 81222 75811
                        <ArrowUpRight
                            className="h-3.5 w-3.5 text-[#8a6d28]"
                            aria-hidden="true"
                        />
                    </a>
                    <span
                        data-testid="contact-location"
                        className="inline-flex items-center gap-2"
                    >
                        <MapPin
                            className="h-4 w-4 text-[#8a6d28]"
                            aria-hidden="true"
                        />
                        Chennai, India
                    </span>
                </Reveal>
            </div>
        </section>
    );
}
